import { render, staticRenderFns } from "./acidpay.vue?vue&type=template&id=1afffe55&scoped=true&"
import script from "./acidpay.vue?vue&type=script&lang=js&"
export * from "./acidpay.vue?vue&type=script&lang=js&"
import style0 from "./acidpay.vue?vue&type=style&index=0&id=1afffe55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afffe55",
  null
  
)

export default component.exports